module.exports = __webpack_public_path__ + "img/pilates6.a9526ed0.jpg";